import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getLedger, updateSingle } from "../../services/projectLedgerService";
// import {
//   getLedgerAccountCompany,
// } from "../../services/projectService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table, Button } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import auth from "../../services/authService";
import { Link } from "react-router-dom";

class ProjectLedgerEditForm extends Form {
  state = {
    imageUrl: false,
    paymentDate: new Date(),
    data: {
      description: "",
      daily_hour: "",
      rate: "",
      // amount: "",
      material_expense: "",
      running_invoices: "",
      debit: "",
      credit: ""
    },
    errors: {},
    roomId: localStorage.getItem("roomId"),
    companyId: ""
  };

  schema = {
    description: Joi.string().required().label("Description"),
    daily_hour: Joi.number().required().label("Daily Hours"),
    rate: Joi.number().required().label("Rate"),
    // amount: Joi.number().required().label("Amount"),
    material_expense: Joi.number().required().label("Material Expense"),
    running_invoices: Joi.label("Running Invoices"),
    debit: Joi.label("Debit"),
    credit: Joi.label("Credit")
  };


  async populateLedger() {
    try {
      const accountId = this.props.match.params.id;

      this.setState({ blocking: true });
      const { data: ledger } = await getLedger(accountId);

      this.setState({
        // paymentDate: ledger.payment_date,

        data: {
          description: ledger.description,
          daily_hour: ledger.daily_hour,
          rate: ledger.rate,
          // amount: ledger.amount,
          material_expense: ledger.material_expense,
          running_invoices: ledger.running_invoices,
          debit: ledger.debit,
          credit: ledger.credit,
        },
        blocking: false,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateLedger();
  }

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  updateLedgerType = (ledgerType) => {
    this.setState({ ledgerType });
  };

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      this.setState({ blocking: true });

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);

      var event = new Date(this.state.paymentDate);

      var utcDate = new Date(
        Date.UTC(
          event.getFullYear(),
          event.getMonth(),
          event.getDate(),
          event.getHours(),
          event.getMinutes()
        )
      );
      let date = JSON.stringify(utcDate);

      date = date.slice(1, 11);
      data.payment_date = date;

      data._method = "PUT";


      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Cost has been updated successfully.");
      const roomId = localStorage.getItem("roomId");
      this.props.history.push("/projects-accounts/view/" + roomId);
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    if (auth.getCurrentUser().email != "client-unblocker@gondalgroup.ae") {
      return "Your are authorized to perform this action.";
    }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Update project ledger" icon="tag" />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "50%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Update ledger</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {/* <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <Button.Group>
                      {this.state.ledgerTypes.map((type) => (
                        <React.Fragment>
                          <Button
                            positive={
                              this.state.ledgerType === type.id ? true : false
                            }
                            onClick={() => this.updateLedgerType(type.id)}
                          >
                            {type.name}
                          </Button>
                        </React.Fragment>
                      ))}
                      ;
                    </Button.Group>
                  </Table.Cell>
                </Table.Row> */}
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("description", "Description", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    <label>
                      <b>Date</b>
                    </label>
                    <br />
                    <DatePicker
                      style={{ width: '200px' }}
                      selected={this.state.paymentDate}
                      onChange={this.handleChangePaymentDate}
                    />


                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("daily_hour", "Daily Hours", "text")}

                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("rate", "Rate", "text")}

                  </Table.Cell>
                  <Table.Cell width="8">
                    {/* {this.renderInput("amount", "Amount", "text")} */}
                    {this.renderInput("material_expense", "Material Expense", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("running_invoices", "Running Invoices", "text")}

                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("debit", "Debit", "text")}

                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("credit", "Credit", "text")}

                  </Table.Cell>
                  <Table.Cell width="8">

                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Update")}
                    <Link
                      to={`/projects-accounts/view/${this.state.roomId}`}
                      className="ui secondary button"
                    >
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default ProjectLedgerEditForm;
